import { JsExpressionConstraint, OclExpressionConstraint } from '../constraint.js';
import { RecordKind } from '../record.js';
export class FilterRegistry {
    constructor(schema) {
        this.schema = schema;
        this.filters = [];
    }
    addFilter(filter) {
        this.filters.push(this.createExpressionConstraint(filter));
    }
    getFiltersForProductType(productType) {
        return this.filters
            .filter(c => c.definition.type === productType)
            .map(c => c.expression);
    }
    createExpressionConstraint(filter) {
        if (filter.kind === RecordKind.OclFilter) {
            return {
                expression: new OclExpressionConstraint(filter.oclExpression, `"${filter.name}" filter is not satisfied`, this.schema),
                definition: filter
            };
        }
        else {
            const filterFn = new Function('self, root', filter.jsExpression);
            return {
                expression: new JsExpressionConstraint(filterFn, `"${filter.name}" filter is not satisfied`),
                definition: filter
            };
        }
    }
    getFiltersByName(filterNames) {
        return this.filters.filter(f => filterNames.includes(f.definition.name));
    }
}
//# sourceMappingURL=FilterRegistry.js.map